import React, { useRef } from 'react';
import { Pie, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import moment from 'moment';

ChartJS.register(ArcElement, Tooltip, Legend);

type DateRange = { start: string; end: string } | { before: string };

type Label = 'This Week' | 'Last Week' | 'This Month' | 'Last Month' | 'This Year' | 'Year Ago';

const NewEmployeeCountPiaChart = ({ peopleOverViewData, setSelectedRange, getEmployees }: any) => {
    const colors = ['#60A5FA', '#34D399', '#F87171', '#FBBF24', '#A78BFA', '#FB923C'];

    // Ensure correct typing
    const labels: Label[] = peopleOverViewData?.newEmolpyeeChart?.labels || [];

    const data = {
        labels,
        datasets: [
            {
                label: 'Employees',
                data: peopleOverViewData?.newEmolpyeeChart?.counts,
                backgroundColor: colors,
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            legend: {
                position: 'bottom' as const,
                labels: {
                    boxWidth: 6,
                    boxHeight: 6,
                    padding: 19,
                    usePointStyle: true,
                    pointStyle: 'circle',
                    font: {
                        size: 13,
                    },
                },
            },
        },
    };
    const now = moment();
    const ranges: Record<Label, DateRange> = {
        'This Week': {
            start: now.clone().startOf('week').format('YYYY-MM-DD'),
            end: now.clone().endOf('week').format('YYYY-MM-DD'),
        },
        'Last Week': {
            start: now.clone().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
            end: now.clone().subtract(1, 'week').endOf('week').format('YYYY-MM-DD'),
        },
        'This Month': {
            start: now.clone().startOf('month').format('YYYY-MM-DD'),
            end: now.clone().endOf('month').format('YYYY-MM-DD'),
        },
        'Last Month': {
            start: now.clone().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
            end: now.clone().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        },
        'This Year': {
            start: now.clone().startOf('year').format('YYYY-MM-DD'),
            end: now.clone().endOf('year').format('YYYY-MM-DD'),
        },
        'Year Ago': {
            before: now.clone().startOf('year').format('YYYY-MM-DD'),
        },
    };

    const chartRef = useRef<any | null>(null);

    const handleClick = (event: any) => {
        const eventData = getElementAtEvent(chartRef.current, event);
        if (!eventData.length) return;

        const index = eventData[0].index;
        const label = labels[index];
        const range = ranges[label];

        setSelectedRange(range);
        let query = `?page=0&limit=10`;

        if ('before' in range) {
            query += `&before=${range.before}`;
        } else {
            query += `&startDate=${range.start}&endDate=${range.end}`;
        }
        getEmployees(query, `Employee Joined ${label}`, range);
        if ('before' in range) {
        } else {
        }
    };

    return (
        <div className="w-full h-full flex flex-col items-center">
            <div className="flex justify-between max-md:flex-col max-md:gap-[10px] w-full">
                <h2 className="text-black text-sm font-black">Employee Joined</h2>
            </div>

            <div className="relative w-full h-[350px] p-3">
                <Pie ref={chartRef} data={data} options={options} onClick={handleClick} />
            </div>
        </div>
    );
};

export default NewEmployeeCountPiaChart;
